import { useLocation } from "react-router-dom";

export const fetchBaseLocation = process.env.REACT_APP_BASE_URL;
export function useQuery() {
  return new URLSearchParams(useLocation().search);
}

export const formatNumber = (value: number) => {
  if (value >= 1_000_000) {
    return `${(value / 1_000_000).toFixed(1)}M`; // Format as millions
  } else if (value >= 1_000) {
    return `${(value / 1_000).toFixed(1)}K`; // Format as thousands
  }
  return value.toString(); // Return as-is for smaller numbers
};
export function capitalize(message: string) {
  return message.charAt(0).toUpperCase() + message.slice(1);
}
